export const MACHINE_CREATE_REQUEST = 'MACHINE_CREATE_REQUEST'
export const MACHINE_CREATE_SUCCESS = 'MACHINE_CREATE_SUCCESS'
export const MACHINE_CREATE_FAIL = 'MACHINE_CREATE_FAIL'
export const MACHINE_CREATE_RESET = 'MACHINE_CREATE_RESET'

export const MACHINE_LIST_REQUEST = 'MACHINE_LIST_REQUEST'
export const MACHINE_LIST_SUCCESS = 'MACHINE_LIST_SUCCESS'
export const MACHINE_LIST_FAIL = 'MACHINE_LIST_FAIL'
export const MACHINE_LIST_RESET = 'MACHINE_LIST_RESET'

export const MACHINE_UPDATE_REQUEST = 'MACHINE_UPDATE_REQUEST'
export const MACHINE_UPDATE_SUCCESS = 'MACHINE_UPDATE_SUCCESS'
export const MACHINE_UPDATE_FAIL = 'MACHINE_UPDATE_FAIL'
export const MACHINE_UPDATE_RESET = 'MACHINE_UPDATE_RESET'

export const MACHINE_DELETE_REQUEST = 'MACHINE_DELETE_REQUEST'
export const MACHINE_DELETE_SUCCESS = 'MACHINE_DELETE_SUCCESS'
export const MACHINE_DELETE_FAIL = 'MACHINE_DELETE_FAIL'
export const MACHINE_DELETE_RESET = 'MACHINE_DELETE_RESET'
